import React, { cloneElement, isValidElement, useId } from 'react';

export interface FieldControlProps {
  id?: string;
  style?: React.CSSProperties;
}

export interface FieldProps {
  label: string;
  id?: string;
  children: React.ReactElement<FieldControlProps>;
}

export function Field({ label, id, children }: FieldProps) {
  const generatedId = useId();
  const controlId = id ?? generatedId;

  const control = isValidElement(children)
    ? cloneElement(children, {
        id: controlId,
        style: {
          height: '36px',
          ...children.props.style,
        },
      })
    : children;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <label htmlFor={controlId} style={{ fontSize: '12px', fontWeight: 600, color: 'var(--text-muted, #6B7280)' }}>
        {label}
      </label>
      {control}
    </div>
  );
}

export default Field;
